
export const Colors = {
    RED : "red",
    BLUE : "blue",
    GREEN : "green",
    YELLOW : "yellow",
}